var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.0607L19.4697 20.5303L20.5303 19.4697L13.0607 12L20.5303 4.53033L19.4697 3.46967L12 10.9393L4.53033 3.46967L3.46967 4.53033L10.9393 12L3.46967 19.4697L4.53033 20.5303L12 13.0607Z",
    fill: "#232527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbClose);
export default __webpack_public_path__ + "static/media/gnb-close.48770c85ccf47cb8f28b15b52e01f58e.svg";
export { ForwardRef as ReactComponent };